import React, { useState } from 'react';
import {
    Box,
    Button,
    Container,
    Grid,
    MenuItem,
    Select,
    Typography,
    FormControl,
    InputLabel,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Modal,
    IconButton,
    TablePagination,
    Chip,
    TextField,
} from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from '@mui/icons-material/Refresh';
import AddIcon from '@mui/icons-material/Add';
// import TableChartIcon from '@mui/icons-material/TableChart';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import AssignmentIcon from '@mui/icons-material/Assignment';
import PeopleIcon from '@mui/icons-material/People';
import DevicesIcon from '@mui/icons-material/Devices';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import ReplayIcon from '@mui/icons-material/Replay';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';

// ─── Mock Data ────────────────────────────────────────────────────────────────

const summaryCards = [
    { label: 'Total Assignments', sub: 'Active assignments', value: 156, color: '#1976d2', bg: '#e3f2fd', icon: <AssignmentIcon sx={{ color: '#1976d2', fontSize: 28 }} /> },
    { label: 'Conductor(s) Assigned', sub: 'Conductor(s)', value: 46, color: '#2e7d32', bg: '#e8f5e9', icon: <PeopleIcon sx={{ color: '#2e7d32', fontSize: 28 }} /> },
    { label: 'POS Machines Assigned', sub: 'Machines', value: 48, color: '#5c35a0', bg: '#ede7f6', icon: <DevicesIcon sx={{ color: '#5c35a0', fontSize: 28 }} /> },
    { label: 'Pending Settlements', sub: 'Assignments', value: 32, color: '#ed6c02', bg: '#fff3e0', icon: <PendingActionsIcon sx={{ color: '#ed6c02', fontSize: 28 }} /> },
    { label: 'Returned Today', sub: 'Assignments', value: 27, color: '#d32f2f', bg: '#ffebee', icon: <AssignmentReturnIcon sx={{ color: '#d32f2f', fontSize: 28 }} /> },
];

const assignmentRows = [
    { id: 1, assignmentId: '5001', assignmentDate: '20/04/2026', conductorId: 1, conductorName: 'Sunil Perera', posMachineId: 10, posSerialNo: 'POS-77881', routeId: 101, routeNo: '001', routeName: 'Colombo - Kandy', assignedBy: 'DepotUser1', assignedAt: '20/04/2026 06:45', returnedAt: '—', settlementStatus: 'Pending' },
    { id: 2, assignmentId: '5002', assignmentDate: '20/04/2026', conductorId: 1, conductorName: 'Sunil Perera', posMachineId: 10, posSerialNo: 'POS-77881', routeId: 102, routeNo: '017', routeName: 'Kandy - Kurunegala', assignedBy: 'DepotUser1', assignedAt: '20/04/2026 06:45', returnedAt: '—', settlementStatus: 'Pending' },
    { id: 3, assignmentId: '5003', assignmentDate: '20/04/2026', conductorId: 2, conductorName: 'Nimal Fernando', posMachineId: 11, posSerialNo: 'POS-88921', routeId: 103, routeNo: '003', routeName: 'Kandy - Matale', assignedBy: 'DepotUser1', assignedAt: '20/04/2026 06:50', returnedAt: '—', settlementStatus: 'Settled' },
    { id: 4, assignmentId: '5004', assignmentDate: '20/04/2026', conductorId: 2, conductorName: 'Nimal Fernando', posMachineId: 11, posSerialNo: 'POS-88921', routeId: 104, routeNo: '019', routeName: 'Matale - Dambulla', assignedBy: 'DepotUser1', assignedAt: '20/04/2026 06:50', returnedAt: '20/04/2026 17:10', settlementStatus: 'Settled' },
    { id: 5, assignmentId: '5005', assignmentDate: '20/04/2026', conductorId: 3, conductorName: 'Priyantha Silva', posMachineId: 12, posSerialNo: 'POS-99012', routeId: 105, routeNo: '025', routeName: 'Kurunegala - Puttalam', assignedBy: 'DepotUser2', assignedAt: '20/04/2026 07:05', returnedAt: '—', settlementStatus: 'Pending' },
    { id: 6, assignmentId: '5006', assignmentDate: '20/04/2026', conductorId: 4, conductorName: 'Saman Kumara', posMachineId: 13, posSerialNo: 'POS-66731', routeId: 106, routeNo: '027', routeName: 'Puttalam - Chilaw', assignedBy: 'DepotUser2', assignedAt: '20/04/2026 07:15', returnedAt: '—', settlementStatus: 'Pending' },
];

const detailRoutes = [
    { routeId: 101, routeNo: '001', routeName: 'Colombo - Kandy' },
    { routeId: 102, routeNo: '017', routeName: 'Kandy - Kurunegala' },
];

// ─── Status chip ──────────────────────────────────────────────────────────────

const StatusChip = ({ status }) => {
    const map = {
        Pending: { bg: '#ed6c02', variant: 'outlined', color: '#ed6c02' },
        Settled: { bg: '#2e7d32', variant: 'outlined', color: '#2e7d32' },
        Returned: { bg: '#1976d2', variant: 'outlined', color: '#1976d2' },
    };
    const cfg = map[status] || { color: '#999' };
    return (
        <Chip label={status} size="small" variant="outlined"
            sx={{ borderColor: cfg.color, color: cfg.color, fontWeight: 600, fontSize: 11, minWidth: 70 }} />
    );
};

// ─── Pagination hook ──────────────────────────────────────────────────────────

const usePagination = (defaultRows = 10) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(defaultRows);
    return {
        page, rowsPerPage,
        handleChangePage: (_, p) => setPage(p),
        handleChangeRowsPerPage: (e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); },
        startIndex: page * rowsPerPage,
    };
};

// ─── Component ────────────────────────────────────────────────────────────────

const ConductorPOSRouteAssignment = () => {

    // Filters
    const [assignmentDate, setAssignmentDate] = useState('20/04/2026');
    const [conductor, setConductor] = useState('');
    const [posMachine, setPosMachine] = useState('');
    const [route, setRoute] = useState('');
    const [settlementStatus, setSettlementStatus] = useState('');

    // Selected row for detail panel
    const [selectedRow, setSelectedRow] = useState(assignmentRows[0]);
    const [detailOpen, setDetailOpen] = useState(true);

    // Add Assignment modal
    const [addOpen, setAddOpen] = useState(false);
    const handleAddOpen = () => setAddOpen(true);
    const handleAddClose = () => setAddOpen(false);

    // Pagination
    const pag = usePagination();

    // Shared cell styles
    const thSx = { py: 1 };
    const tdSx = { py: 0 };

    const handleRowClick = (row) => {
        setSelectedRow(row);
        setDetailOpen(true);
    };

    return (
        <Container component="main" maxWidth="full" sx={{ py: 0 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>

                {/* ── Page Title ── */}
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, mt: 3 }}>
                    <Typography variant="h5" sx={{ fontWeight: 700 }}>
                        Conductor POS Route Assignment
                    </Typography>
                    <IconButton size="small"><MoreHorizIcon /></IconButton>
                </Box>

                <Grid
                    container
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
                        gap: 2,
                        mb: 3,
                        width: '100%'
                    }}
                >
                    {summaryCards.map((card) => (
                        <Paper
                            key={card.label}
                            variant="outlined"
                            sx={{
                                p: 2,
                                borderRadius: 2,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 2
                            }}
                        >
                            <Box
                                sx={{
                                    backgroundColor: card.bg,
                                    borderRadius: 2,
                                    p: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                {card.icon}
                            </Box>

                            <Box>
                                <Typography variant="body2" color="text.secondary" sx={{ fontSize: 11 }}>
                                    {card.label}
                                </Typography>

                                <Typography
                                    variant="h5"
                                    sx={{ fontWeight: 700, color: card.color, lineHeight: 1.2 }}
                                >
                                    {card.value}
                                </Typography>

                                <Typography variant="caption" color="text.secondary">
                                    {card.sub}
                                </Typography>
                            </Box>
                        </Paper>
                    ))}
                </Grid>

                {/* ── Filter Bar ── */}
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                        gap: 1.5,
                        width: '100%',
                        mb: 1,
                        alignItems: 'end'
                    }}
                >
                    {/* Date */}
                    <TextField
                        fullWidth
                        size="small"
                        type="date"
                        label="Assignment Date"
                        value={assignmentDate}
                        onChange={e => setAssignmentDate(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                    />

                    {/* Conductor */}
                    <FormControl size="small" fullWidth>
                        <InputLabel>Conductor</InputLabel>
                        <Select value={conductor} onChange={e => setConductor(e.target.value)} label="Conductor">
                            <MenuItem value="">All Conductors</MenuItem>
                            <MenuItem value="1">Sunil Perera</MenuItem>
                            <MenuItem value="2">Nimal Fernando</MenuItem>
                            <MenuItem value="3">Priyantha Silva</MenuItem>
                            <MenuItem value="4">Saman Kumara</MenuItem>
                        </Select>
                    </FormControl>

                    {/* POS Machine */}
                    <FormControl size="small" fullWidth>
                        <InputLabel>POS Machine</InputLabel>
                        <Select value={posMachine} onChange={e => setPosMachine(e.target.value)} label="POS Machine">
                            <MenuItem value="">All Machines</MenuItem>
                            <MenuItem value="POS-77881">POS-77881</MenuItem>
                            <MenuItem value="POS-88921">POS-88921</MenuItem>
                            <MenuItem value="POS-99012">POS-99012</MenuItem>
                            <MenuItem value="POS-66731">POS-66731</MenuItem>
                        </Select>
                    </FormControl>

                    {/* Route */}
                    <FormControl size="small" fullWidth>
                        <InputLabel>Route</InputLabel>
                        <Select value={route} onChange={e => setRoute(e.target.value)} label="Route">
                            <MenuItem value="">All Routes</MenuItem>
                            <MenuItem value="101">Colombo - Kandy</MenuItem>
                            <MenuItem value="102">Kandy - Kurunegala</MenuItem>
                            <MenuItem value="103">Kandy - Matale</MenuItem>
                            <MenuItem value="104">Matale - Dambulla</MenuItem>
                            <MenuItem value="105">Kurunegala - Puttalam</MenuItem>
                            <MenuItem value="106">Puttalam - Chilaw</MenuItem>
                        </Select>
                    </FormControl>

                    {/* Settlement Status */}
                    <FormControl size="small" fullWidth>
                        <InputLabel>Settlement Status</InputLabel>
                        <Select value={settlementStatus} onChange={e => setSettlementStatus(e.target.value)} label="Settlement Status">
                            <MenuItem value="">All Status</MenuItem>
                            <MenuItem value="pending">Pending</MenuItem>
                            <MenuItem value="settled">Settled</MenuItem>
                            <MenuItem value="returned">Returned</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                {/* ── Action Buttons ── */}
                <Box sx={{ display: 'flex', gap: 1.5, mb: 3, alignItems: 'center', width: '100%', justifyContent: 'flex-end' }}>
                    <Button variant="contained" startIcon={<SearchIcon />}
                        sx={{ padding: '6px 24px', fontWeight: 'bold', borderRadius: '4px', height: '40px', backgroundColor: '#3f51b5', color: '#fff', '&:hover': { backgroundColor: '#303f9f' } }}>
                        Search
                    </Button>
                    <Button variant="outlined" startIcon={<RefreshIcon />}
                        sx={{ fontWeight: 'bold', borderRadius: '4px', height: '40px', textTransform: 'none' }}>
                        Reset
                    </Button>
                    <Button variant="contained" startIcon={<AddIcon />}
                        onClick={handleAddOpen}
                        sx={{ padding: '6px 20px', fontWeight: 'bold', borderRadius: '4px', height: '40px', backgroundColor: '#2e7d32', color: '#fff', '&:hover': { backgroundColor: '#1b5e20' } }}>
                        New Assignment
                    </Button>
                </Box>

                {/* ══════════════════════════════════════════
                    TABLE — POS Route Assignments
                ══════════════════════════════════════════ */}
                <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                    {/* <TableChartIcon sx={{ color: '#1976d2', fontSize: 20 }} /> */}
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>POS Route Assignments</Typography>
                </Box>

                <TableContainer component={Paper} sx={{ width: '100%' }}>
                    <Table>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#7cdffa4b' }}>
                                <TableCell sx={thSx}>Assignment ID</TableCell>
                                <TableCell sx={thSx}>Assignment Date</TableCell>
                                <TableCell sx={thSx}>Conductor (ID)</TableCell>
                                <TableCell sx={thSx}>Conductor Name</TableCell>
                                <TableCell sx={thSx}>POS Machine (ID)</TableCell>
                                <TableCell sx={thSx}>POS Serial No.</TableCell>
                                <TableCell sx={thSx}>Route (ID)</TableCell>
                                <TableCell sx={thSx}>Route No.</TableCell>
                                <TableCell sx={thSx}>Route Name</TableCell>
                                <TableCell sx={thSx}>Assigned By</TableCell>
                                <TableCell sx={thSx}>Assigned At</TableCell>
                                <TableCell sx={thSx}>Returned At</TableCell>
                                <TableCell sx={thSx}>Settlement Status</TableCell>
                                <TableCell sx={thSx}>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {assignmentRows
                                .slice(pag.startIndex, pag.startIndex + pag.rowsPerPage)
                                .map((row) => (
                                    <TableRow key={row.id}
                                        onClick={() => handleRowClick(row)}
                                        sx={{ cursor: 'pointer', backgroundColor: selectedRow?.id === row.id ? '#f0f7ff' : 'inherit', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                        <TableCell sx={tdSx}>
                                            <Typography variant="body2" sx={{ color: '#1976d2', fontWeight: 600 }}>
                                                {row.assignmentId}
                                            </Typography>
                                        </TableCell>
                                        <TableCell sx={tdSx}>{row.assignmentDate}</TableCell>
                                        <TableCell sx={tdSx}>{row.conductorId}</TableCell>
                                        <TableCell sx={tdSx}>{row.conductorName}</TableCell>
                                        <TableCell sx={tdSx}>{row.posMachineId}</TableCell>
                                        <TableCell sx={tdSx}>{row.posSerialNo}</TableCell>
                                        <TableCell sx={tdSx}>{row.routeId}</TableCell>
                                        <TableCell sx={tdSx}>{row.routeNo}</TableCell>
                                        <TableCell sx={tdSx}>{row.routeName}</TableCell>
                                        <TableCell sx={tdSx}>{row.assignedBy}</TableCell>
                                        <TableCell sx={tdSx}>{row.assignedAt}</TableCell>
                                        <TableCell sx={tdSx}>{row.returnedAt}</TableCell>
                                        <TableCell sx={tdSx}><StatusChip status={row.settlementStatus} /></TableCell>
                                        <TableCell sx={tdSx}>
                                            <Button size="small" endIcon={<KeyboardArrowDownIcon />}
                                                sx={{ minWidth: 0, p: '2px 6px', borderRadius: '4px', border: '1px solid #ccc', color: '#555', textTransform: 'none' }}>
                                                •••
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                    <TablePagination
                        showFirstButton showLastButton
                        component="div"
                        count={assignmentRows.length}
                        page={pag.page}
                        onPageChange={pag.handleChangePage}
                        rowsPerPage={pag.rowsPerPage}
                        onRowsPerPageChange={pag.handleChangeRowsPerPage}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                    />
                </TableContainer>

                {/* ══════════════════════════════════════════
                    DETAIL PANEL — Assignment Details
                ══════════════════════════════════════════ */}
                {selectedRow && (
                    <Paper variant="outlined" sx={{ width: '100%', mt: 3, borderRadius: 2, overflow: 'hidden' }}>
                        {/* Panel header */}
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5, backgroundColor: '#f5f5f5', borderBottom: '1px solid #e0e0e0' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <IconButton size="small" onClick={() => setDetailOpen(!detailOpen)}>
                                    {detailOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                </IconButton>
                                <Typography variant="h6" sx={{ fontWeight: 600 }}>Assignment Details</Typography>
                            </Box>
                        </Box>

                        {detailOpen && (
                            <Box sx={{ p: 2 }}>
                                <Grid container spacing={2}>

                                    {/* Left — field grid */}
                                    <Grid item xs={12} md={4}>
                                        <Grid container spacing={1}>
                                            {[
                                                { label: 'Assignment ID', value: selectedRow.assignmentId },
                                                { label: 'Assignment Date', value: selectedRow.assignmentDate },
                                                { label: 'Conductor', value: `${selectedRow.conductorName} (EMP${selectedRow.conductorId}025)` },
                                                { label: 'POS Machine', value: selectedRow.posSerialNo },
                                                { label: 'Assigned By', value: selectedRow.assignedBy },
                                                { label: 'Assigned At', value: selectedRow.assignedAt },
                                            ].map((f) => (
                                                <React.Fragment key={f.label}>
                                                    <Grid item xs={5}>
                                                        <Typography variant="body2" color="text.secondary">{f.label}</Typography>
                                                    </Grid>
                                                    <Grid item xs={7}>
                                                        <Typography variant="body2" sx={{ fontWeight: 500 }}>{f.value}</Typography>
                                                    </Grid>
                                                </React.Fragment>
                                            ))}
                                        </Grid>
                                        <Grid container spacing={1}>
                                            {[
                                                { label: 'Returned At', value: selectedRow.returnedAt },
                                                { label: 'Settlement Status', value: selectedRow.settlementStatus, isChip: true },
                                                { label: 'Remarks', value: '—' },
                                            ].map((f) => (
                                                <React.Fragment key={f.label}>
                                                    <Grid item xs={5}>
                                                        <Typography variant="body2" color="text.secondary">{f.label}</Typography>
                                                    </Grid>
                                                    <Grid item xs={7}>
                                                        {f.isChip
                                                            ? <StatusChip status={f.value} />
                                                            : <Typography variant="body2" sx={{ fontWeight: 500 }}>{f.value}</Typography>
                                                        }
                                                    </Grid>
                                                </React.Fragment>
                                            ))}
                                        </Grid>
                                    </Grid>



                                    {/* Middle-right — routes table */}
                                    <Grid item xs={12} md={5}>
                                        <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                                            Routes Assigned in This Assignment (Same Day & POS)
                                        </Typography>
                                        <TableContainer component={Paper} variant="outlined">
                                            <Table size="small">
                                                <TableHead>
                                                    <TableRow sx={{ backgroundColor: '#7cdffa4b' }}>
                                                        <TableCell sx={{ py: 0.5, fontSize: 12 }}>Route ID</TableCell>
                                                        <TableCell sx={{ py: 0.5, fontSize: 12 }}>Route No.</TableCell>
                                                        <TableCell sx={{ py: 0.5, fontSize: 12 }}>Route Name</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {detailRoutes.map((r) => (
                                                        <TableRow key={r.routeId}>
                                                            <TableCell sx={{ py: 0, fontSize: 12 }}>{r.routeId}</TableCell>
                                                            <TableCell sx={{ py: 0, fontSize: 12 }}>{r.routeNo}</TableCell>
                                                            <TableCell sx={{ py: 0, fontSize: 12 }}>{r.routeName}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>

                                    {/* Right — action buttons */}
                                    <Grid item xs={12} md={3}>
                                        <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>Actions</Typography>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                            <Button variant="outlined" startIcon={<ReplayIcon />} fullWidth
                                                sx={{ borderRadius: '4px', textTransform: 'none', justifyContent: 'flex-start', fontWeight: 600, borderColor: '#1976d2', color: '#1976d2' }}>
                                                Return POS
                                            </Button>
                                            <Button variant="outlined" startIcon={<CheckCircleIcon />} fullWidth
                                                sx={{ borderRadius: '4px', textTransform: 'none', justifyContent: 'flex-start', fontWeight: 600, borderColor: '#2e7d32', color: '#2e7d32' }}>
                                                Mark as Settled
                                            </Button>
                                            <Button variant="outlined" startIcon={<VisibilityIcon />} fullWidth
                                                sx={{ borderRadius: '4px', textTransform: 'none', justifyContent: 'flex-start', fontWeight: 600, borderColor: '#5c35a0', color: '#5c35a0' }}>
                                                View Settlement
                                            </Button>
                                            <Button variant="outlined" startIcon={<DeleteIcon />} fullWidth
                                                sx={{ borderRadius: '4px', textTransform: 'none', justifyContent: 'flex-start', fontWeight: 600, borderColor: '#d32f2f', color: '#d32f2f' }}>
                                                Delete Assignment
                                            </Button>
                                        </Box>
                                    </Grid>

                                </Grid>
                            </Box>
                        )}
                    </Paper>
                )}

                {/* ══════════════════════════════════════════
                    Add Assignment Modal — same style as sample
                ══════════════════════════════════════════ */}
                <Modal open={addOpen} onClose={handleAddClose}>
                    <Box sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '90%',
                        maxWidth: 560,
                        bgcolor: 'background.paper',
                        border: '2px solid gray',
                        boxShadow: 24,
                        p: 4,
                        borderRadius: '10px',
                    }}>
                        <Typography variant="h6" gutterBottom>New Assignment</Typography>

                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <TextField fullWidth size="small" label="Assignment Date" defaultValue="20/04/2026" sx={{ mb: 1 }} />
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth size="small" sx={{ mb: 1 }}>
                                    <InputLabel>Conductor</InputLabel>
                                    <Select defaultValue="" label="Conductor">
                                        <MenuItem value="1">Sunil Perera</MenuItem>
                                        <MenuItem value="2">Nimal Fernando</MenuItem>
                                        <MenuItem value="3">Priyantha Silva</MenuItem>
                                        <MenuItem value="4">Saman Kumara</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth size="small" sx={{ mb: 1 }}>
                                    <InputLabel>POS Machine</InputLabel>
                                    <Select defaultValue="" label="POS Machine">
                                        <MenuItem value="POS-77881">POS-77881</MenuItem>
                                        <MenuItem value="POS-88921">POS-88921</MenuItem>
                                        <MenuItem value="POS-99012">POS-99012</MenuItem>
                                        <MenuItem value="POS-66731">POS-66731</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth size="small" sx={{ mb: 1 }}>
                                    <InputLabel>Route</InputLabel>
                                    <Select defaultValue="" label="Route">
                                        <MenuItem value="101">Colombo - Kandy</MenuItem>
                                        <MenuItem value="102">Kandy - Kurunegala</MenuItem>
                                        <MenuItem value="103">Kandy - Matale</MenuItem>
                                        <MenuItem value="104">Matale - Dambulla</MenuItem>
                                        <MenuItem value="105">Kurunegala - Puttalam</MenuItem>
                                        <MenuItem value="106">Puttalam - Chilaw</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField fullWidth size="small" label="Remarks" multiline rows={2} />
                            </Grid>
                        </Grid>

                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                            <Button variant="contained" color="primary" onClick={handleAddClose} sx={{ marginRight: '8px' }}>
                                Save
                            </Button>
                            <Button variant="contained" onClick={handleAddClose} sx={{ backgroundColor: 'gray' }}>
                                Cancel
                            </Button>
                        </Box>
                    </Box>
                </Modal>

            </Box>
        </Container>
    );
};

export default ConductorPOSRouteAssignment;